export enum Operations {
    CREATE_AND_MODIFY_RELEASE_STRATEGY = 1,
    ASSIGNMENT_OF_POINTS_ON_CONSIGNMENT_TO_PARTNERS = 2,
    POINT_ALLOCATION_INVITATION_AND_MASS_DEACTIVATION = 3,
    PARTNER_BLOCKING = 4,
    POINTS_CADUCITY_UPDATE = 5,
    POINTS_CONVERSION_RATE_UPDATE = 6,
    MINT_POINTS_TO_MAIN_WALLET = 7,
    PARTNER_CREATION = 8, //
    PROGRAM_CREATION = 10,
    CREATE_OR_MODIFY_PARTNER_ADMIN = 11,
    CREATE_OR_MODIFY_PROGRAM_ADMIN = 12,
    CREATE_OR_MODIFY_CUSTOMER_SERVICE_ADMIN = 13,
    CREATE_OR_MODIFY_OPERATION_MANAGER_ADMIN = 14,
    MODIFY_PROGRAM_DATA = 15,
    MODIFY_LIMIT_POINTS_ON_CONSIGNMENT = 16, //
    REVERT_TRANSACTION = 17,
    TERMS_AND_CONDITIONS_DOCS_UPDATE = 18,
    CLIENT_DATA_UPDATE = 19,
    PROGRAM_BLOCKING = 20,
    UPLOAD_GIFTCARD_STOCK = 21,
    DELETE_GIFTCARD_PDF = 22,
    UPLOAD_GIFTCARD_PDF = 23
}
